module.exports = __webpack_public_path__ + "img/Data-pipeline-3.424fbb31.png";